import { render } from "./CodeMirror.vue?vue&type=template&id=fb9f1ac8"
import script from "./CodeMirror.vue?vue&type=script&lang=js"
export * from "./CodeMirror.vue?vue&type=script&lang=js"

import "./CodeMirror.vue?vue&type=style&index=0&id=fb9f1ac8&lang=scss"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__